import { API_URL } from '../../../../utils/config';

const PayslipUrl = {
  CREATE_PAYSLIP_URL: `${API_URL}/payslip`,
  SEARCH_PAYSLIP_URL: `${API_URL}/payslip/search`,
  DOWNLOAD_USER_PAYSLIP_URL: `https://slot.tizeti.com/payslip/payslip.php`,
};

export default PayslipUrl;
